import styled from 'styled-components';
import { UpgradeIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledText = styled(Text)(({
  theme
}) => ({
  fontSize: theme.typography['body-100'].fontSize
}));
const DefaultBanner = ({
  button,
  titleText,
  subtext,
  dataTestId,
  marginStyle,
  replacementIcon
}) => {
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingBlock: "200",
    paddingInline: "400",
    backgroundColor: "fill-primary-subtle",
    role: "alert",
    "data-test-id": dataTestId
  }, marginStyle, {
    children: [replacementIcon || /*#__PURE__*/_jsx(IconCircle, {
      marginBlockEnd: "300",
      borderWidth: "0",
      size: "600",
      icon: UpgradeIcon,
      color: "fill-primary-default",
      padding: "0",
      marginBlock: "0",
      marginInlineEnd: "300"
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(StyledText, {
        as: "strong",
        children: titleText
      }), "\xA0", subtext, "\xA0", button]
    })]
  }));
};
export default DefaultBanner;